import React, { useState, useEffect } from "react";

import AddList from "../../../components/yourAssets/BOA/goldRawMaterials/AddList";
import Summary from "../../../components/yourAssets/BOA/goldRawMaterials/Summary";
import { getGoldRm } from "../../../services/yourAssets/goldRawMaterialServices";
import SuggestionBox from "../../../common/suggestionBox/SuggestionBox";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";

import { useDispatch, useSelector } from "react-redux";
import { nextCard } from "../../../redux/slices/CardSlices";
import { getUserIdFromLocalStorage } from "../../../utils/Utilities";

const GoldRawMaterials = ({ next, back, tabText }) => {
  let uID = getUserIdFromLocalStorage();
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [goldRmData, setGoldRmData] = useState([]);
  const [summaryValues, setSummaryValues] = useState([]);
  const [updationFlag, setUpdationFlag] = useState(false);
  const [continueButton, setContinueButton] = useState(true);
  const dispatch = useDispatch();
  const currentCard = useSelector((state) => state.currentCard.currentCard);
  const updates = useSelector((state) => state.auditTrail.updates);
  const handlePreSetUsersData = () => {
    const updtedSelectedProperties = goldRmData.map((el) => {
      return {
        id: el.id,
        name: el.name,
      };
    });
    setSelectedProperties(updtedSelectedProperties);
  };
  const getGoldRmList = async () => {
    let apiResult = await getGoldRm(uID);
    if (apiResult?.success) {
      let usersData = apiResult?.payLoad?.map((el) => {
        let mainOwner = el.Material;
        let subOwner = el.Material.subMaterials;
        const obj = {
          id: mainOwner.materialCategoryId,
          name: el.materialCategoryName,
          materialId: mainOwner?.materialId,
          translationKey: el?.translationKey || "",
          owner: {
            id: mainOwner.materialId,
            designation: mainOwner.designation,
            name: mainOwner.owner,
            ownership: mainOwner.ownerShipPercentage,
            value: mainOwner.value,
            weight: mainOwner.weight,
            subOwners: subOwner?.map((item) => {
              let subObj = {
                materialId: mainOwner.materialId,
                subMaterialId: item.subMaterialId,
                id: item.subMaterialId,
                quantity: item.quantity,
                name: item.owner,
                ownership: item.ownerShipPercentage,
                value: item.value,
                weight: item.weight,
              };
              return subObj;
            }),
          },
        };
        setContinueButton(false);
        return obj;
      });
      setGoldRmData(usersData);
      if (usersData.length > 0) {
        setUpdationFlag(true);
        if (currentCard == 1) {
          dispatch(nextCard());
        }
      }
    }
  };
  const handlePreSetApiSummaryValues = () => {
    let updatedSummaryValues = [];
    selectedProperties.forEach((el) => {
      let matchedObj = goldRmData.filter((item, index) => item.id === el.id);
      if (matchedObj.length > 0) {
        updatedSummaryValues.push(matchedObj[0]);
      } else {
        updatedSummaryValues.push(el);
      }
    });
    setSummaryValues([...updatedSummaryValues]);
  };
  useEffect(() => {
    getGoldRmList();
  }, []);

  useEffect(() => {
    handlePreSetUsersData();
  }, [goldRmData]);
  useEffect(() => {
    handlePreSetApiSummaryValues();
  }, [selectedProperties]);
  const deleteMainOwner = (id) => {
    const updatedSummaryValues = summaryValues.filter((el) => el.id !== id);

    setSummaryValues(updatedSummaryValues);
  };

  const handleSetProperties = (obj) => {
    const value = selectedProperties.find((item) => {
      if (item.id === obj.id) return true;
      return false;
    });
    if (value !== undefined) {
      setSelectedProperties((pre) =>
        pre.filter((item) => item.id !== value.id)
      );
    } else {
      setSelectedProperties((pre) => [...pre, obj]);
    }
    setContinueButton(true);
  };

  const handleSetSummaryValues = (arr) => {
    setSummaryValues(arr);
  };

  const handleResetSummaryValues = () => {
    setSummaryValues([...selectedProperties]);
  };

  const handleDeleteSummaryRow = (id) => {
    setSummaryValues((pre) => [
      ...pre.map((item) => {
        if (item.id === id) {
          return selectedProperties.find((ele) => ele.id === id);
        }
        return item;
      }),
    ]);
  };

  const renderTab = () => {
    if (currentCard === 1) {
      return (
        <AddList
          selectedProperties={selectedProperties}
          handleSetProperties={handleSetProperties}
        />
      );
    } else if (currentCard === 2) {
      return (
        <Summary
          next={next}
          selectedProperties={selectedProperties}
          summaryValues={summaryValues}
          handleSetSummaryValues={handleSetSummaryValues}
          handleResetSummaryValues={handleResetSummaryValues}
          handleDeleteSummaryRow={handleDeleteSummaryRow}
          updationFlag={updationFlag}
          deleteMainOwner={deleteMainOwner}
          disableContinueButton={continueButton}
          updates={updates}
        />
      );
    }
  };
  return (
    <>
      {renderTab()}
      <SuggestionBox mainText={tabText} setVisited={visited} />
    </>
  );
};

export default GoldRawMaterials;
